"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyIdListSchema = exports.CompanySchema = void 0;
const zod_1 = require("zod");
const licenseItem_1 = require("./licenseItem");
exports.CompanySchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    // TODO(CAR-571): remove, superseded by licenseItems
    hasFuelAccess: zod_1.z.boolean(),
    licenseItems: zod_1.z.array(zod_1.z.nativeEnum(licenseItem_1.LicenseItem)),
});
exports.CompanyIdListSchema = zod_1.z
    .array(zod_1.z.string().uuid())
    .min(1, 'Pass at least one company id');
//# sourceMappingURL=company.js.map